import React, { Component } from "react";
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import ReactTable from "react-table";
import moment from 'moment';
import Geral from '../../Utils/Geral';
import InputTag from '../../Components/Input-Tag/Input-Tag';
import Select, { makeAnimated } from 'react-select';
import './Editions-List-Register.scss';
import ErrorModal from "../ErrorModal/ErrorModal";
import ModalEditarEdicao from "../../Components/Modal-Editar-Edicao/Modal-Editar-Edicao";



class EditionsListRegister extends Component {

    constructor(props) {
        super(props);

        this.carregaListaEdicoes = this.carregaListaEdicoes.bind(this);
        this.refreshTable = this.refreshTable.bind(this);
        this.atualizaNumeroEdicao = this.atualizaNumeroEdicao.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.toggleModalEditar = this.toggleModalEditar.bind(this);
        this.handleModalEditar = this.handleModalEditar.bind(this);



        this.Configurations = new Configurations();

        this.periodicsOptions = [
            { label: "BS", value: 1 },
            { label: "BJ", value: 2 },
            { label: "TC", value: 3 },
        ]

        this.state = {
            isLoadingEditions: true,
            listaPeriodicos: [],
            listaNumeroEdicao: [],
            modalEditar: false
        }

        this.columns = [
            {
                Header: "Nº edição",
                accessor: 'numeroEdicao',
                className: "text-center pointer",
                width: 150
            },
            {
                Header: "Periódico",
                accessor: 'sigla',
                className: "text-center pointer",
                width: 150,
                Cell: row => <React.Fragment>
                    <span className={`badge badge-${!!row.original.sigla && (Geral.obtemTipoBadge(row.original.sigla).badgeColor)}`}>{row.original.sigla}</span> ({row.original.idProduto})
                </React.Fragment>
            },
            {
                Header: "Data limite assinatura",
                accessor: 'dtLimiteAssinatura',
                className: "text-center pointer",
                width: 250,
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY') : '-'}</span>)
            },
            {
                Header: "Data fechamento redação",
                accessor: 'dtRedacaoFechamento',
                className: "text-center pointer",
                width: 250,
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY') : '-'}</span>)
            },
            {
                Header: "Data entrega",
                accessor: 'dtEntrega',
                className: "text-center pointer",
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY') : '-'}</span>)
            }
        ]
    }



    carregaListaEdicoes(o) {

        this.setState({ isLoadingEditions: true })

        const _params = [];

        if (!o || !o.pageSize) {

            o.pageSize = 20;
            _params.push(`limite=${o.pageSize}`);
        } else if (!(o.page + 1)) {
            o.page = 1;
            _params.push(`pagina=${o.page}`);
        } else {
            _params.push(`limite=${o.pageSize}`);
            _params.push(`pagina=${o.page + 1}`);
        }
        if (this.state.listaPeriodicos.length > 0) {
            _params.push(`periodicos=${this.state.listaPeriodicos.join(',')}`);
        }

        if (this.state.listaNumeroEdicao.length > 0) {
            _params.push(`numeroEdicao=${this.state.listaNumeroEdicao.join(',')}`);
        }

        const _parametros = _params.join('&');
        axios.get(this.Configurations.apiBasePath + `/edicoes/assinatura/impressos?${_params.join('&')}`)
            .then(response => {
                this.setState({
                    edicoes: response.data.data,
                    paginasEdicoes: response.data.paginacao.totalPaginas,
                    paginaAtual: response.data.paginacao.paginaAtual,
                    parametros: _parametros
                });
            }).catch(this.handleError).finally(() => this.setState({ isLoadingEditions: false }));
    }

    refreshTable(o) {
        this.carregaListaEdicoes(o);
    }

    atualizaNumeroEdicao(_lista) {
        this.setState({ listaNumeroEdicao: _lista })
    }


    handleSelectChange(a, o) {
        let _list = this.state.listaPeriodicos;
        switch (o.action) {
            case "remove-value":
                const _index = _list.findIndex(item => item === o.removedValue.label);
                _list.splice(_index, 1);
                break;
            case "clear":
                _list = [];
                break;
            default:
                _list.push(o.option.label)
                break;
        }
        this.setState({
            listaPeriodicos: _list,
        })
        return o;
    }

    handleError(err) {

        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.data.message : 'Erro inesperado.' })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    handleModalEditar(_infosEdicao) {
        this.setState({ infosModal: _infosEdicao }, () => this.toggleModalEditar())
    }

    toggleModalEditar() {
        this.setState({ modalEditar: !this.state.modalEditar })
    }

    render() {
        return (
            <div className='row editions-list'>
                <div className='col-12'>
                    <h2>Lista de Edições</h2>
                    <div className='row align-items-center py-1'>
                        <div className='col-3 tags-periodico mt-2'>
                            <label> Busca por número de edição</label>
                            <InputTag atualizaTags={this.atualizaNumeroEdicao} tags={this.state.listaNumeroEdicao} textInput={true} />
                            <small>Insira o nº da(s) edição(ões) e pressione "Enter" ou "Tab".</small>
                        </div>
                        <div className="col-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="ddlPeriodico">Periódico</label>
                                <Select
                                    id="ddlPeriodico"
                                    placeholder="Selecione um ou mais periódicos"
                                    closeMenuOnSelect={true}
                                    components={makeAnimated()}
                                    defaultValue={this.state.listaPeriodicos}
                                    isMulti
                                    name="listaPeriodicos"
                                    onChange={this.handleSelectChange}
                                    options={this.periodicsOptions}
                                />
                            </div>
                        </div>
                        <div className='col-2'>
                            <button className='btn btn-outline-info' onClick={() => this.carregaListaEdicoes({ pageSize: 20, page: 0 })}>buscar</button>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body p-0">
                                    <ReactTable
                                        data={this.state.edicoes}
                                        columns={this.columns}
                                        onFetchData={this.refreshTable}
                                        defaultPageSize={20}
                                        pages={this.state.paginasEdicoes}
                                        manual
                                        loading={this.state.isLoadingEditions}
                                        className="-striped -highlight"
                                        headerClassName="ebs-table-header"
                                        previousText='Anterior'
                                        nextText='Próximo'
                                        loadingText='Carregando...'
                                        noDataText='Nenhuma edição encontrada.'
                                        pageText='Página'
                                        ofText='de'
                                        rowsText='linhas'
                                        getTrProps={(state, rowInfo, column, instance) => {
                                            return {
                                                onClick: (e, handleOriginal) => {
                                                    this.handleModalEditar(rowInfo.original)
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {!!this.state.infosModal && (
                    <ModalEditarEdicao
                        toggle={this.toggleModalEditar}
                        isOpen={this.state.modalEditar}
                        edicao={this.state.infosModal}
                        carregaListaEdicoes={this.carregaListaEdicoes}
                    />
                )}

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div>

        )
    }
}

export default EditionsListRegister;